import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        {" | "}
        <Link to="/terms-of-service">Terms of Service</Link>
      </div>
      <p>&copy; {new Date().getFullYear()} Lan4ai. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
